var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    rx: 7,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 89.2827C96.6931 89.2827 115 92.4552 115 104.695C115 116.94 96.5731 120 75 120C53.3119 120 35 116.827 35 104.587C35 92.3427 53.4269 89.2827 75 89.2827ZM75 30C89.6955 30 101.47 40.5931 101.47 53.8097C101.47 67.0264 89.6955 77.624 75 77.624C60.3095 77.624 48.5301 67.0264 48.5301 53.8097C48.5301 40.5931 60.3095 30 75 30Z",
    fill: "#06C0B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.c1102374646c51d47db3570f050fac7e.svg";
export { ForwardRef as ReactComponent };